module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


if (getLang() == 'ru') {
	moment.locale('ru');
}

for (var year in data) {
;
__p += '\n<div class="table">\n	<table>\n		<caption>' +
((__t = (year.slice(5))) == null ? '' : __t) +
'</caption>\n		<thead>\n			<tr>\n				<th width="200px">' +
((__t = ( localize({
					ru: 'Дата',
					en: 'Date'
				}))) == null ? '' : __t) +
'</th>\n				<th>' +
((__t = ( localize({
					ru: 'Событие',
					en: 'Event'
				}))) == null ? '' : __t) +
'</th>\n				<th>' +
((__t = ( localize({
					ru: 'Напомнить',
					en: 'Add to calendar'
				}))) == null ? '' : __t) +
'</th>\n				<th>' +
((__t = ( localize({
					ru: 'Поделиться',
					en: 'Share'
				}))) == null ? '' : __t) +
'</th>\n				<th>' +
((__t = ( localize({
					ru: 'Место проведения',
					en: 'Venue'
				}))) == null ? '' : __t) +
'</th>\n			</tr>\n		</thead>\n		<tbody>\n';

	for (var month in data[year]) {
;
__p += '\n		<tr>\n			<td colspan="5" class="events__tr events__tr--heading">' +
((__t = ( moment(month.slice(5), 'MM').format('MMMM'))) == null ? '' : __t) +
'</td>\n		</tr>\n';

		data[year][month].forEach(function (el) {
;
__p += '\n			<tr class="events__tr events__tr--' +
((__t = (el.type)) == null ? '' : __t) +
'" data-id="' +
((__t = (el.id)) == null ? '' : __t) +
'">\n				<td>\n					';

						var arDates = el.date.split('-'),
								outDate = '';
						if (arDates.length > 1) {
							var date1 = moment.unix(parseInt(arDates[0])).format("DD MMMM YYYY"),
									date2 = moment.unix(parseInt(arDates[1])).format("DD MMMM YYYY");

							if (moment.unix(parseInt(arDates[0])).format('YYYY') == moment.unix(parseInt(arDates[1])).format('YYYY')) {
								date1 = moment.unix(parseInt(arDates[0])).format("DD MMMM");
								if (moment.unix(parseInt(arDates[0])).format('MM') == moment.unix(parseInt(arDates[1])).format('MM')) {
									date1 = moment.unix(parseInt(arDates[0])).format("DD");
								}
							}
							outDate = date1 + ' - ' + date2;
						} else {
							outDate = moment.unix(parseInt(el.date)).format("DD MMMM YYYY");
						}
					;
__p += '\n					' +
((__t = ( outDate)) == null ? '' : __t) +
'\n				</td>\n				<td>' +
((__t = (el.name)) == null ? '' : __t) +
'</td>\n				<td class="u-relative">\n					<span class="events__icon events__icon--remember js-cal-remember" data-google="' +
((__t = ( el.remember.google )) == null ? '' : __t) +
'" data-yahoo="' +
((__t = ( el.remember.yahoo )) == null ? '' : __t) +
'" data-outlook="' +
((__t = ( el.remember.outlook )) == null ? '' : __t) +
'" data-ical="' +
((__t = ( el.remember.ical )) == null ? '' : __t) +
'"></span>\n				</td>\n				<td class="u-relative">\n					<span class="events__icon events__icon--share js-cal-share" data-fb="https://www.facebook.com/sharer/sharer.php?u=' +
((__t = ( location.href)) == null ? '' : __t) +
'&title=' +
((__t = ( el.name)) == null ? '' : __t) +
'" data-tw="https://twitter.com/intent/tweet?text=' +
((__t = ( el.name)) == null ? '' : __t) +
'&url=' +
((__t = ( location.href)) == null ? '' : __t) +
'" data-vk="http://vk.com/share.php?url=' +
((__t = ( location.href)) == null ? '' : __t) +
'&title=' +
((__t = ( el.name)) == null ? '' : __t) +
'"></span>\n				</td>\n				<td>\n					';
 if (el.hasOwnProperty('venue')) { ;
__p += '\n						' +
((__t = (el.venue)) == null ? '' : __t) +
'\n					';
 } ;
__p += '\n				</td>\n			</tr>\n';

		})
	}
;
__p += '\n		</tbody>\n	</table>\n</div>\n';

}
;
__p += '\n';

}
return __p
}